import React from 'react';
import PropTypes from 'prop-types';
import { ClerkProvider } from '@clerk/clerk-react';

import AuthGateInner from '~/components/shared/AuthGateInner';

const publishableKey = process.env.CLERK_PUBLISHABLE_KEY;
if (!publishableKey) {
  console.warn(
    'CLERK_PUBLISHABLE_KEY is not defined. Clerk will not initialize.',
  );
}

export default function AuthGate({ children }) {
  return (
    <ClerkProvider publishableKey={publishableKey}>
      <AuthGateInner>{children}</AuthGateInner>
    </ClerkProvider>
  );
}

AuthGate.propTypes = {
  children: PropTypes.node,
};

AuthGate.defaultProps = {
  children: null,
};
